<template>
  <div class="fund-investment-page">
    <!-- 横幅部分 -->
    <section class="hero-banner">
      <!-- 内容区域 -->
      <div class="banner-content">
        <div class="text-content">
          <h1 class="brand-name">{{ hero_brand_name }}</h1>
          <h2 class="main-title">{{ hero_title }}</h2>
          <a :href="resolveActionLink(hero_button_link)" target="_blank" rel="noopener noreferrer" class="cta-button inline-block">{{ hero_button_text }}</a>
        </div>
      </div>
    </section>

    <!-- Longbridge优势板块 -->
    <section class="longbridge-advantages py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <!-- 标题 -->
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">
            {{ advantages_title }}
          </h2>
        </div>

        <!-- 优势卡片网格 -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">

          <!-- 第一行左侧：免佣优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <!-- 橙色盾牌图标 -->
              <img :src="advantage1_icon" alt="advantage1">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage1_text }}
              </p>
            </div>
          </div>

          <!-- 第一行右侧：技术工具优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <!-- 橙色圆形定位针图标 -->
              <img :src="advantage2_icon" alt="advantage2">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage2_text }}
              </p>
            </div>
          </div>

          <!-- 第二行左侧：市场覆盖优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
            <img :src="advantage3_icon" class="w-13 h-13" alt="advantage3">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage3_text }}
              </p>
            </div>
          </div>

          <!-- 第二行右侧：出入金方式优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
              <img :src="advantage4_icon" alt="advantage4">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage4_text }}
              </p>
            </div>
          </div>

          <!-- 第三行左侧：个性化服务优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
             <img :src="advantage5_icon" alt="advantage5">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage5_text }}
              </p>
            </div>
          </div>

          <!-- 第三行右侧：安全保障优势 -->
          <div class="advantage-card flex items-start space-x-4">
            <div class="icon-container">
             <img :src="advantage6_icon" alt="advantage6">
            </div>
            <div class="flex-1">
              <p class="text-gray-900 text-base leading-relaxed">
                {{ advantage6_text }}
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- 专享特权板块 -->
    <section class="exclusive-privileges py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div class="bg-white rounded-lg p-8 shadow-sm" v-for="(module, idx) in privilege_modules" :key="idx">
            <h3 class="text-2xl lg:text-3xl font-bold text-gray-900 mb-6">{{ module.title }}</h3>
            <ul class="space-y-4 mb-6">
              <li class="flex items-start" v-for="(item, index) in (module.items || []).slice(0, 3)" :key="index">
                <span class="w-2 h-2 bg-[#ef7c5b] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span class="text-gray-700 leading-relaxed">{{ item }}</span>
              </li>
            </ul>
            <a :href="resolveActionLink(module.button_link || module.button_url || privilege_button_link)" target="_blank" rel="noopener noreferrer" class="bg-[#ef7c5b] cursor-pointer inline-block text-white px-8 py-2 rounded-3xl font-semibold transition-colors">{{ module.button_text || privilege_button_text }}</a>
          </div>
        </div>
      </div>
    </section>

    

    <!-- 交易能力板块 -->

    <!-- 值得信赖的证券经纪服务商 -->
    <section class="trusted-broker py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="text-center mb-6">
          <h2 class="text-3xl lg:text-4xl font-bold text-gray-900">{{ trusted_title }}</h2>
          <p class="text-base text-gray-800 max-w-3xl mx-auto mt-3">
            {{ trusted_subtitle }}
          </p>
        </div>

        <!-- 三列服务优势卡片 -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">

          <div class="service-card bg-white rounded-lg p-6 shadow-sm" v-for="(service, index) in trusted_services" :key="index">
            <div class="icon-top flex items-center justify-center mb-4">
                <img :src="service.icon" :alt="service.title">
            </div>
            <h4 class="text-lg font-semibold text-gray-900 mb-3 text-center">{{ service.title }}</h4>
            <ul class="text-gray-700 list-none space-y-3" v-if="service.items">
              <li class="flex items-start" v-for="(item, iIndex) in service.items" :key="iIndex"><span class="w-2 h-2 bg-black rounded-full mt-2 mr-3 flex-shrink-0"></span><span>{{ item }}</span></li>
            </ul>
          </div>

        </div>
      </div>
    </section>

    <!-- 荣誉奖项展示 -->
    <section class="awards-section bg-white py-16 lg:py-24">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 text-center mb-10">{{ awards_title }}</h2>

        <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" v-if="awards">
          <div class="award-item text-center" v-for="(award, index) in awards" :key="index">
            <div class="award-card mx-auto">
              <img :src="resolveAwardImage(award, index)" :alt="award.lines[0]" class="w-full h-auto" />
            </div>
            <div class="award-caption mt-4 text-gray-800 text-sm leading-5">
              <div v-for="(line, lIndex) in award.lines" :key="lIndex">{{ line }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 支持账户类型 -->
    <section class="account-types py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 lg:px-8 text-center">
        <h2 class="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">{{ accounts_title }}</h2>
        <p class="text-base text-gray-800 mb-8">{{ accounts_subtitle }}</p>

        <!-- 图标行 -->
        <div class="flex items-center justify-center gap-12 mb-6">
          <div class="flex flex-col items-center" v-for="(account, index) in account_types" :key="index">
            <img :src="account.icon" :alt="account.name">
            <div class="text-gray-900">{{ account.name }}</div>
          </div>
        </div>

        <!-- 详细说明框 -->
        <div class="max-w-3xl mx-auto border border-gray-200 rounded-lg p-6 bg-white text-left">
          <h4 class="font-semibold text-gray-900 mb-2">{{ account_description.title }}</h4>
          <p class="text-gray-700 text-sm leading-relaxed">
            {{ account_description.content }}
          </p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { ContentMixin, addServerPrefix } from '../services/contentService';

export default {
  name: 'FundInvestment',
  mixins: [ContentMixin],
  data() {
    return {
      // 英雄区配置
      hero_brand_name: '红土证券',
      hero_title: '基金投资',
      hero_button_text: '立即开户',
      hero_button_link: '',
      default_trading_url: 'https://redland.trade.wbrks.com/Webtrading',

      // 优势板块
      advantages_title: '基金投资优势',
      advantage1_icon: '/assets/kh1.png',
      advantage1_text: '基金交易0申赎费，帮您节省每一分投资成本，专注长期价值投资。',
      advantage2_icon: '/assets/kh4.png',
      advantage2_text: '专业的基金筛选工具，帮您选择优质基金产品，降低投资风险。',
      advantage3_icon: '/assets/kh2.png',
      advantage3_text: '覆盖全球知名基金公司产品，包括主动型、被动型、混合型等多种基金类型。',
      advantage4_icon: '/assets/kh5.png',
      advantage4_text: '便捷的基金申赎流程，支持定期定额投资，养成良好投资习惯。',
      advantage5_icon: '/assets/kh3.png',
      advantage5_text: '专业的基金投资顾问，为您提供个性化的基金配置建议和服务。',
      advantage6_icon: '/assets/kh6.png',
      advantage6_text: '严格的风控体系，多重安全保障，确保您的基金投资安全可靠。',

      // 特权板块
      privilege_image: '/assets/image3.png',
      privilege_title: '基金投资专属特权',
      privilege_items: [
        '零申赎费基金交易，节省投资成本',
        '专业的基金研究报告和投资建议',
        '优先认购热门新基金',
        '专属基金经理一对一服务'
      ],
      privilege_highlight: '申赎费用 0',
      privilege_button_text: '了解详情',
      privilege_button_link: '',
      privilege_modules: [
        { title: '基金投资专属特权 A', items: ['零申赎费基金交易，节省投资成本','专业的基金研究报告和投资建议','优先认购热门新基金'], button_text: '了解详情' },
        { title: '基金投资专属特权 B', items: ['专属基金经理一对一服务','定期投资报告和策略调整','VIP客户专属活动邀请'], button_text: '了解详情' },
        { title: '基金投资专属特权 C', items: ['客户资产独立托管','严格的风控审核','多重安全防护体系'], button_text: '了解详情' }
      ],


      // 交易能力
      trading_title: '强大的基金交易能力',
      trading_capabilities: [
        {
          icon: '/assets/khb1.png',
          title: '全终端覆盖',
          features: ['支持桌面端和移动端', '随时随地进行基金交易']
        },
        {
          icon: '/assets/khb2.png',
          title: '丰富基金产品',
          features: ['覆盖全球知名基金公司', '主动型、被动型、混合型基金']
        },
        {
          icon: '/assets/khb3.png',
          title: '快速交易执行',
          features: ['毫秒级订单处理', '确保及时申赎']
        },
        {
          icon: '/assets/khb4.png',
          title: '灵活申赎方式',
          features: ['支持单笔申赎和定期定额', '满足不同投资需求']
        },
        {
          icon: '/assets/khb5.png',
          title: '智能风控系统',
          features: ['实时风险监控', '保障账户资金安全']
        }
      ],

      // 值得信赖
      trusted_title: '值得信赖的基金投资服务',
      trusted_subtitle: '我们以专业、安全、合规的服务，为您的基金投资保驾护航',
      trusted_services: [
        {
          icon: '/assets/zh11.png',
          title: '资产安全保障',
          items: [
            '客户资产独立托管',
            '严格的风控审核',
            '多重安全防护体系'
          ]
        },
        {
          icon: '/assets/zh22.png',
          title: '数据安全与隐私',
          items: [
            'ISO27001信息安全认证',
            '加密传输和存储',
            '严格的隐私保护政策'
          ]
        },
        {
          icon: '/assets/zh33.png',
          title: '专业服务团队',
          items: [
            '资深基金投资顾问',
            '7x24小时客户服务',
            '个性化投资方案定制'
          ]
        }
      ],

      // 账户类型
      accounts_title: '支持账户类型',
      accounts_subtitle: '个人和机构投资者均可开户，享受专业的基金投资服务',
      account_types: [
        {
          icon: '/assets/khd1.png',
          name: '个人账户'
        },
        {
          icon: '/assets/khd2.png',
          name: '机构账户'
        }
      ],
      account_description: {
        title: '机构账户说明',
        content: '机构账户专为专业投资机构和理财师设计，提供更丰富的基金产品和更优惠的手续费率。如需开设机构账户，请联系我们的客户经理。'
      }
    }
  },
  computed: {
    awards_title() {
      return this.getContent('fund_awards_title', '荣誉奖项展示');
    },
    awards() {
      const awardsJson = this.getContent('fund_awards', '[{"image":"image_fund_award_1","lines":["最佳基金投资平台奖 2023","亚洲金融科技创新奖","香港金融科技卓越奖"]},{"image":"image_fund_award_2","lines":["最佳客户服务奖 2023","国际投资论坛金奖","亚洲证券经纪商评选"]},{"image":"image_fund_award_3","lines":["最佳移动交易APP奖","金融科技创新领先奖"]},{"image":"image_fund_award_4","lines":["最佳投资研究报告奖","亚洲最佳经纪商评选"]}]');
      try {
        return this.normalizeAwards(JSON.parse(awardsJson));
      } catch (e) {
        console.error('解析基金投资荣誉奖项数据失败:', e);
        return this.normalizeAwards([
          {
            image: "image_fund_award_1",
            lines: [
              '最佳基金投资平台奖 2023',
              '亚洲金融科技创新奖',
              '香港金融科技卓越奖'
            ]
          },
          {
            image: "image_fund_award_2",
            lines: [
              '最佳客户服务奖 2023',
              '国际投资论坛金奖',
              '亚洲证券经纪商评选'
            ]
          },
          {
            image: "image_fund_award_3",
            lines: [
              '最佳移动交易APP奖',
              '金融科技创新领先奖'
            ]
          },
          {
            image: "image_fund_award_4",
            lines: [
              '最佳投资研究报告奖',
              '亚洲最佳经纪商评选'
            ]
          }
        ]);
      }
    }
  },
  async   mounted() {
    // 从API加载配置数据
    this.loadContentData();

    // 监听语言切换事件
    window.addEventListener('localeChange', this.handleLocaleChange);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('localeChange', this.handleLocaleChange);
  },
  methods: {
    resolveActionLink(url) {
      if (typeof url === 'string' && url.trim()) {
        return url.trim();
      }
      return this.default_trading_url;
    },
    normalizeImageUrl(url) {
      if (!url || typeof url !== 'string') return '';
      return addServerPrefix(url.trim());
    },
    normalizeAwards(awards) {
      if (!Array.isArray(awards)) return [];
      return awards.map((award, index) => {
        const awardData = (award && typeof award === 'object') ? award : {};
        const image = typeof awardData.image === 'string' && awardData.image.trim()
          ? awardData.image.trim()
          : `image_fund_award_${index + 1}`;
        const lines = Array.isArray(awardData.lines) ? awardData.lines : [];
        return { ...awardData, image, lines };
      });
    },
    normalizeIconItems(items) {
      if (!Array.isArray(items)) return [];
      return items.map(item => {
        if (!item || typeof item !== 'object') return item;
        const normalized = { ...item };
        if (typeof normalized.icon === 'string') {
          normalized.icon = this.normalizeImageUrl(normalized.icon);
        }
        return normalized;
      });
    },
    resolveAwardImage(award, index) {
      const defaultImages = ['/assets/kh1.png', '/assets/kh2.png', '/assets/kh3.png', '/assets/kh4.png'];
      const defaultImage = defaultImages[index] || defaultImages[0];
      const imageRef = award && award.image ? award.image : `image_fund_award_${index + 1}`;

      if (typeof imageRef !== 'string' || !imageRef.trim()) {
        return defaultImage;
      }

      const trimmed = imageRef.trim();
      if (
        trimmed.startsWith('/assets/') ||
        trimmed.startsWith('/uploads/') ||
        trimmed.startsWith('http://') ||
        trimmed.startsWith('https://')
      ) {
        return this.normalizeImageUrl(trimmed);
      }

      return this.getImageUrl(trimmed, defaultImage);
    },
    async loadContentData() {
      try {
        const response = await fetch('/api/public/investment-pages/fund');
        if (response.ok) {
          const data = await response.json();
          if (data.code === 0 && data.data) {
            this.parseContentData(data.data);
          }
        }
      } catch (error) {
        console.error('加载内容数据失败:', error);
        // 使用默认数据
      }
    },
    parseContentData(data) {
      // 获取当前语言
      const currentLang = this.$i18n ? this.$i18n.locale : 'zh';
      console.log('基金投资页面解析数据，当前语言:', currentLang, '数据长度:', data.length);

      // 根据当前语言解析配置数据
      const getLocalizedValue = (key) => {
        const item = data.find(item => item.key === key);
        if (item) {
          let value;
          switch (currentLang) {
            case 'en':
              value = item.value_en || item.value_cn;
              break;
            case 'zh-Hant':
              value = item.value_tw || item.value_cn;
              break;
            default:
              value = item.value_cn;
              break;
          }
          return value;
        }
        return null;
      };

      // 解析英雄区数据
      this.hero_brand_name = getLocalizedValue('fund_hero_brand_name') || this.hero_brand_name;
      this.hero_title = getLocalizedValue('fund_hero_title') || this.hero_title;
      this.hero_button_text = getLocalizedValue('fund_hero_button_text') || this.hero_button_text;
      this.hero_button_link = this.resolveActionLink(
        getLocalizedValue('fund_hero_button_link') ||
        getLocalizedValue('fund_hero_button_url') ||
        this.hero_button_link
      );

      // 解析优势标题
      this.advantages_title = getLocalizedValue('fund_advantages_title') || this.advantages_title;

      // 解析优势图标
      const advantage1_icon = this.normalizeImageUrl(getLocalizedValue('fund_advantage1_icon') || this.advantage1_icon);
      const advantage2_icon = this.normalizeImageUrl(getLocalizedValue('fund_advantage2_icon') || this.advantage2_icon);
      const advantage3_icon = this.normalizeImageUrl(getLocalizedValue('fund_advantage3_icon') || this.advantage3_icon);
      const advantage4_icon = this.normalizeImageUrl(getLocalizedValue('fund_advantage4_icon') || this.advantage4_icon);
      const advantage5_icon = this.normalizeImageUrl(getLocalizedValue('fund_advantage5_icon') || this.advantage5_icon);
      const advantage6_icon = this.normalizeImageUrl(getLocalizedValue('fund_advantage6_icon') || this.advantage6_icon);

      this.advantage1_icon = advantage1_icon;
      this.advantage2_icon = advantage2_icon;
      this.advantage3_icon = advantage3_icon;
      this.advantage4_icon = advantage4_icon;
      this.advantage5_icon = advantage5_icon;
      this.advantage6_icon = advantage6_icon;

      // 将图片URL同步到ContentMixin的imageUrls中
      this.$set(this.imageUrls, 'fund_advantage1_icon', advantage1_icon);
      this.$set(this.imageUrls, 'fund_advantage2_icon', advantage2_icon);
      this.$set(this.imageUrls, 'fund_advantage3_icon', advantage3_icon);
      this.$set(this.imageUrls, 'fund_advantage4_icon', advantage4_icon);
      this.$set(this.imageUrls, 'fund_advantage5_icon', advantage5_icon);
      this.$set(this.imageUrls, 'fund_advantage6_icon', advantage6_icon);

      // 解析优势文本
      this.advantage1_text = getLocalizedValue('fund_advantage1_text') || this.advantage1_text;
      this.advantage2_text = getLocalizedValue('fund_advantage2_text') || this.advantage2_text;
      this.advantage3_text = getLocalizedValue('fund_advantage3_text') || this.advantage3_text;
      this.advantage4_text = getLocalizedValue('fund_advantage4_text') || this.advantage4_text;
      this.advantage5_text = getLocalizedValue('fund_advantage5_text') || this.advantage5_text;
      this.advantage6_text = getLocalizedValue('fund_advantage6_text') || this.advantage6_text;

      // 解析特权板块
      const privilege_image = this.normalizeImageUrl(getLocalizedValue('fund_privilege_image') || this.privilege_image);
      this.privilege_image = privilege_image;
      this.privilege_title = getLocalizedValue('fund_privilege_title') || this.privilege_title;
      this.privilege_highlight = getLocalizedValue('fund_privilege_highlight') || this.privilege_highlight;
      this.privilege_button_text = getLocalizedValue('fund_privilege_button_text') || this.privilege_button_text;
      this.privilege_button_link = this.resolveActionLink(
        getLocalizedValue('fund_privilege_button_link') ||
        getLocalizedValue('fund_privilege_button_url') ||
        this.privilege_button_link
      );

      // 将图片URL同步到ContentMixin的imageUrls中
      this.$set(this.imageUrls, 'fund_privilege_image', privilege_image);

      // 解析特权列表
      const privilegeItemsStr = getLocalizedValue('fund_privilege_items');
      if (privilegeItemsStr) {
        try {
          this.privilege_items = JSON.parse(privilegeItemsStr);
        } catch (e) {
          console.error('解析特权列表失败:', e);
        }
      }

      // 解析特权模块（每卡独立配置）
      const privilegeModulesStr = getLocalizedValue('fund_privilege_modules');
      if (privilegeModulesStr) {
        try {
          const modules = JSON.parse(privilegeModulesStr);
          if (Array.isArray(modules) && modules.length) {
            this.privilege_modules = modules.slice(0, 3).map(module => {
              if (!module || typeof module !== 'object') return module;
              const normalized = { ...module };
              if (typeof normalized.image === 'string') {
                normalized.image = this.normalizeImageUrl(normalized.image);
              }
              if (typeof normalized.icon === 'string') {
                normalized.icon = this.normalizeImageUrl(normalized.icon);
              }
              normalized.button_link = this.resolveActionLink(
                normalized.button_link || normalized.button_url || normalized.link || this.privilege_button_link
              );
              return normalized;
            });
          }
        } catch (e) {
          console.error('解析特权模块失败:', e);
        }
      } else {
        // 回退：用已有标题/列表构造三卡，确保页面可用
        this.privilege_modules = [
          { title: this.privilege_title, items: (this.privilege_items || []).slice(0, 3), button_text: this.privilege_button_text, button_link: this.privilege_button_link },
          { title: this.privilege_title, items: (this.privilege_items || []).slice(0, 3), button_text: this.privilege_button_text, button_link: this.privilege_button_link },
          { title: this.privilege_title, items: (this.privilege_items || []).slice(0, 3), button_text: this.privilege_button_text, button_link: this.privilege_button_link }
        ];
      }



      // 解析交易能力标题
      this.trading_title = getLocalizedValue('fund_trading_title') || this.trading_title;

      // 解析交易能力列表
      const tradingCapabilitiesStr = getLocalizedValue('fund_trading_capabilities');
      if (tradingCapabilitiesStr) {
        try {
          this.trading_capabilities = this.normalizeIconItems(JSON.parse(tradingCapabilitiesStr));
        } catch (e) {
          console.error('解析交易能力列表失败:', e);
        }
      }

      // 解析值得信赖板块
      this.trusted_title = getLocalizedValue('fund_trusted_title') || this.trusted_title;
      this.trusted_subtitle = getLocalizedValue('fund_trusted_subtitle') || this.trusted_subtitle;

      // 解析服务列表
      const trustedServicesStr = getLocalizedValue('fund_trusted_services');
      if (trustedServicesStr) {
        try {
          this.trusted_services = this.normalizeIconItems(JSON.parse(trustedServicesStr));
        } catch (e) {
          console.error('解析服务列表失败:', e);
        }
      }

      // 解析荣誉奖项标题与内容（多语言）
      const awardsTitle = getLocalizedValue('fund_awards_title') || '荣誉奖项展示';
      this.$set(this.contentData, 'fund_awards_title', awardsTitle);
      const awardsStr = getLocalizedValue('fund_awards');
      if (awardsStr) {
        this.$set(this.contentData, 'fund_awards', awardsStr);
      } else {
        this.$set(this.contentData, 'fund_awards', '[{"image":"image_fund_award_1","lines":["最佳基金投资平台奖 2023","亚洲金融科技创新奖","香港金融科技卓越奖"]},{"image":"image_fund_award_2","lines":["最佳客户服务奖 2023","国际投资论坛金奖","亚洲证券经纪商评选"]},{"image":"image_fund_award_3","lines":["最佳移动交易APP奖","金融科技创新领先奖"]},{"image":"image_fund_award_4","lines":["最佳投资研究报告奖","亚洲最佳经纪商评选"]}]');
      }

      // 荣誉奖项现在由computed属性处理，不需要在这里赋值

      // 解析账户类型
      this.accounts_title = getLocalizedValue('fund_accounts_title') || this.accounts_title;
      this.accounts_subtitle = getLocalizedValue('fund_accounts_subtitle') || this.accounts_subtitle;

      // 解析账户类型列表
      const accountTypesStr = getLocalizedValue('fund_account_types');
      if (accountTypesStr) {
        try {
          this.account_types = this.normalizeIconItems(JSON.parse(accountTypesStr));
        } catch (e) {
          console.error('解析账户类型列表失败:', e);
        }
      }

      // 解析账户描述
      const accountDescriptionStr = getLocalizedValue('fund_account_description');
      if (accountDescriptionStr) {
        try {
          this.account_description = JSON.parse(accountDescriptionStr);
        } catch (e) {
          console.error('解析账户描述失败:', e);
        }
      }

      // 解析荣誉奖项图片并同步到ContentMixin的imageUrls中
      const image_fund_award_1 = getLocalizedValue('image_fund_award_1') || '/assets/kh1.png';
      const image_fund_award_2 = getLocalizedValue('image_fund_award_2') || '/assets/kh2.png';
      const image_fund_award_3 = getLocalizedValue('image_fund_award_3') || '/assets/kh3.png';
      const image_fund_award_4 = getLocalizedValue('image_fund_award_4') || '/assets/kh4.png';

      this.$set(this.imageUrls, 'image_fund_award_1', this.normalizeImageUrl(image_fund_award_1));
      this.$set(this.imageUrls, 'image_fund_award_2', this.normalizeImageUrl(image_fund_award_2));
      this.$set(this.imageUrls, 'image_fund_award_3', this.normalizeImageUrl(image_fund_award_3));
      this.$set(this.imageUrls, 'image_fund_award_4', this.normalizeImageUrl(image_fund_award_4));
    },
    handleLocaleChange() {
      // 当语言切换时，重新解析数据
      console.log('基金投资页面语言切换事件触发，重新加载数据');
      this.loadContentData().then(() => {
        // 强制更新视图
        this.$forceUpdate();
        console.log('基金投资页面视图已强制更新');
      });
    }
  },
  metaInfo: {
    title: '基金投资 - 红土证券'
  }
}
</script>

<style scoped>
/* 复用 DelegateCustomer.vue 的样式 */
.hero-banner {
  position: relative;
  height: 40vh;
  min-height: 600px;
  overflow: hidden;
  background:url("https://img.shetu66.com/2023/07/04/1688453333865029.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* 天空渐变背景 */
.sky-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    #1e3a8a 0%,
    #3b82f6 30%,
    #60a5fa 60%,
    #93c5fd 100%
  );
}

/* 云朵样式 */
.cloud {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50px;
  animation: float-cloud 20s ease-in-out infinite;
}

.cloud-1 {
  width: 120px;
  height: 40px;
  top: 15%;
  left: 10%;
  animation-delay: 0s;
}

.cloud-2 {
  width: 80px;
  height: 30px;
  top: 25%;
  right: 15%;
  animation-delay: 5s;
}

.cloud-3 {
  width: 100px;
  height: 35px;
  top: 35%;
  left: 20%;
  animation-delay: 10s;
}

@keyframes float-cloud {
  0%, 100% {
    transform: translateX(0px) translateY(0px);
  }
  25% {
    transform: translateX(10px) translateY(-5px);
  }
  50% {
    transform: translateX(-5px) translateY(-10px);
  }
  75% {
    transform: translateX(-10px) translateY(-5px);
  }
}

/* 岩石样式 */
.rock {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 60%;
  height: 80%;
  background: linear-gradient(135deg, #8B4513 0%, #654321 50%, #A0522D 100%);
  clip-path: polygon(
    20% 100%,
    30% 90%,
    45% 95%,
    60% 85%,
    75% 90%,
    85% 80%,
    95% 85%,
    100% 75%,
    90% 65%,
    95% 50%,
    85% 40%,
    90% 25%,
    80% 15%,
    70% 10%,
    60% 5%,
    50% 0%,
    40% 5%,
    30% 0%,
    20% 10%,
    15% 20%,
    10% 30%,
    5% 40%,
    0% 50%,
    5% 60%,
    0% 70%,
    10% 80%,
    15% 90%,
    20% 100%
  );
  box-shadow: inset -20px -20px 40px rgba(0, 0, 0, 0.3);
}

/* 添加岩石纹理效果 */
.rock::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 30% 30%, rgba(139, 69, 19, 0.3) 1px, transparent 1px),
    radial-gradient(circle at 70% 20%, rgba(160, 82, 45, 0.2) 1px, transparent 1px),
    radial-gradient(circle at 50% 60%, rgba(101, 67, 33, 0.4) 2px, transparent 2px);
  background-size: 20px 20px, 15px 15px, 25px 25px;
}

/* 树木样式 */
.trees {
  position: absolute;
}

.left-trees {
  left: 5%;
  top: 20%;
  height: 60%;
}

.top-trees {
  top: 5%;
  left: 30%;
  right: 30%;
  height: 20%;
  display: flex;
  justify-content: space-around;
}

.tree {
  position: relative;
  background: linear-gradient(135deg, #0f5132 0%, #1e3a8a 100%);
  border-radius: 50% 50% 0 0;
  box-shadow: inset 0 -10px 20px rgba(0, 0, 0, 0.3);
}

.left-trees .tree {
  width: 40px;
  height: 120px;
  margin-bottom: 20px;
}

.tree-1 {
  transform: rotate(-5deg);
  margin-left: 10px;
}

.tree-2 {
  transform: rotate(3deg);
  margin-left: -5px;
}

.tree-3 {
  transform: rotate(-2deg);
  margin-left: 15px;
}

.top-trees .tree {
  width: 25px;
  height: 60px;
}

.tree-4 {
  transform: rotate(-8deg);
}

.tree-5 {
  transform: rotate(6deg);
}

/* 内容区域 */
.banner-content {
  position: absolute;
  top: 50%;
  left: 15%;
  transform: translateY(-50%);
  z-index: 10;
}

.text-content {
  text-align: left;
}

.brand-name {
  font-size: 1.5rem;
  font-weight: 300;
  color: white;
  margin-bottom: 0.5rem;
  letter-spacing: 0.1em;
}

.main-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 2rem;
  letter-spacing: 0.05em;
  line-height: 1.1;
}

.cta-button {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.05em;
}

.cta-button:hover {
  background: white;
  color: #1e3a8a;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

/* 委托客户内容样式 */
.delegate-content {
  min-height: 400px;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .hero-banner {
    height: 80vh;
    min-height: 500px;
  }

  .rock {
    width: 70%;
    height: 70%;
  }

  .main-title {
    font-size: 2.5rem;
  }

  .banner-content {
    left: 10%;
  }
}

@media (max-width: 768px) {
  .hero-banner {
    height: 70vh;
    min-height: 400px;
  }

  .rock {
    width: 80%;
    height: 60%;
  }

  .left-trees {
    left: 2%;
    top: 25%;
  }

  .main-title {
    font-size: 2rem;
  }

  .brand-name {
    font-size: 1.2rem;
  }

  .banner-content {
    left: 8%;
  }

  .cta-button {
    padding: 0.6rem 1.5rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 640px) {
  .hero-banner {
    height: 60vh;
    min-height: 350px;
  }

  .rock {
    width: 90%;
    height: 50%;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .brand-name {
    font-size: 1rem;
  }

  .banner-content {
    left: 5%;
  }

  .left-trees {
    display: none; /* 在小屏幕上隐藏左侧树木以节省空间 */
  }
}

/* 专享特权板块样式 */
.privilege-cards {
  position: relative;
}

.privilege-card {
  min-height: 400px;
}

.icon-wrapper {
  width: 3rem;
  height: 3rem;
  background: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tag {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.privilege-item {
  padding: 0.75rem 0;
  border-bottom: 1px solid #f3f4f6;
}

.privilege-item:last-child {
  border-bottom: none;
}

.highlight-box {
  border-radius: 0.375rem;
}

/* 移动端响应式调整 */
@media (max-width: 768px) {
  .advantage-card {
    padding: 1rem;
  }

  .advantage-card .flex {
    flex-direction: column;
    align-items: center;
  }

  .advantage-card .space-x-4 > * + * {
    margin-left: 0;
    margin-top: 1rem;
  }

  .advantage-card p {
    font-size: 0.875rem;
    line-height: 1.5;
    text-align: center;
  }

  .icon-container {
    width: 2.5rem;
    height: 2.5rem;
  }

  .privilege-card {
    min-height: auto;
    padding: 1.5rem;
  }

  .text-content h3 {
    font-size: 1.875rem;
    margin-bottom: 1rem;
  }

  .privilege-item {
    padding: 0.5rem 0;
  }

  .icon-wrapper {
    width: 2.5rem;
    height: 2.5rem;
  }
}

/* 投资者工具板块样式 */
.phone-showcase {
  perspective: 1000px;
}

.phone-mockup {
  transform: rotateY(-5deg);
}

.phone-frame {
  width: 280px;
  max-width: 90vw;
}

.phone-screen {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
}

.tab {
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s;
}

.tab.active {
  background-color: #3b82f6;
  color: white;
}

.rating-section {
  border: 1px solid #dbeafe;
}

.chart-placeholder {
  position: relative;
}

.related-companies {
  border-top: 1px solid #e5e7eb;
  padding-top: 0.5rem;
}

/* 交易能力板块样式 */
.capability-card {
  border: 1px solid #e5e7eb;
}

.capability-card .icon-container {
  width: 3rem;
  height: 3rem;
  background: #f9fafb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

/* 技术领先板块样式 */
.nav-tab {
  padding: 0.75rem 1rem;
  font-weight: 500;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  position: relative;
}

.nav-tab.active {
  color: #1f2937;
  border-bottom-color: #1f2937;
}

.nav-tab:hover {
  color: #374151;
}

.content-box {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #ececec;
  box-shadow: 0 6px 18px rgba(16,24,40,0.03);
  padding: 2.5rem;
  text-align: left;
}

.advantages-grid {
  max-width: 1200px;
  margin: 0 auto;
}

.advantage-item .icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

.advantage-item .icon-wrapper::before {
  /* dashed square border */
  content: '';
  position: absolute;
  width: 56px;
  height: 56px;
  border: 1px dashed rgba(249,115,22,0.35);
  border-radius: 8px;
  left: -4px;
  top: -4px;
}

.advantage-item .icon-inner {
  width: 36px;
  height: 36px;
  background: #fff7ed;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f97316;
  z-index: 2;
}

/* 移动端响应式调整 */
@media (max-width: 1024px) {
  .phone-mockup {
    transform: rotateY(0deg);
  }

  .phone-frame {
    width: 240px;
  }
}

@media (max-width: 768px) {
  .investor-tools .grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .text-content {
    order: 2;
  }

  .phone-showcase {
    order: 1;
  }

  .phone-frame {
    width: 200px;
  }

  .phone-screen {
    height: 320px;
  }

  .text-content h3 {
    font-size: 1.875rem;
    text-align: center;
  }

  .text-content ul {
    text-align: left;
  }
}

@media (max-width: 640px) {
  .phone-frame {
    width: 180px;
    height: 280px;
    padding: 0.75rem;
  }

  .app-header .flex {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .tab {
    font-size: 0.625rem;
    padding: 0.125rem 0.25rem;
  }
}

/* 支持账户类型样式 */
.account-types .account-icon {
  box-shadow: 0 8px 20px rgba(16,24,40,0.06);
}
.account-icon svg { fill: white; }
.service-card .icon-circle img { width: 100%; height: 100%; object-fit: cover;}
</style>
